module.exports = __webpack_public_path__ + "img/delete-red-icon.d8eaa519.svg";